module.exports = __webpack_public_path__ + "static/img/bg-id.0c83aa11.webp";